import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { theme } from '@frontend/theme';
import type { AvailabilityMode } from '../../../components/availability/availability-form/types';
import { NewAvailabilityRulesExperienceBadgeBanner } from '../../../components/badge-banners/new-availability-rules-experience-badge-banner';
import { AvailabilityModeSection } from './components/availability-mode-section/availability-mode-section';
import { AvailabilityRuleListSection } from './components/availability-rule-list-section';

type Props = {
  locationId: string;
};

export const AvailabilityRules = ({ locationId }: Props) => {
  const listLocationSettingsQuery = SchedulerV3.Queries.useListLocationSettingsQuery({
    request: { locationIds: [locationId] },
  });

  const availabilityMode = (listLocationSettingsQuery.data?.locationsSettings?.[locationId]?.availabilityLens ||
    'PROVIDER') as AvailabilityMode;

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2), position: 'relative' }}>
      <NewAvailabilityRulesExperienceBadgeBanner locationId={locationId} />
      <AvailabilityModeSection currentMode={availabilityMode} locationId={locationId} />
      <AvailabilityRuleListSection locationId={locationId} availabilityMode={availabilityMode} />
    </div>
  );
};
